export default __webpack_public_path__ + "static/media/MST03.5b8fc38c.png";